import React from 'react';

import Model from 'src/storage/base';
import config from 'src/config';
import { MCText } from 'src/components/basic';
import LANG_CONST from 'src/helpers/lang/const';
import { ThumbnailUploader } from 'src/components/complex';
import AlertManager from 'src/components/alert/AlertManager';
import { checkSameAsAvatar } from 'src/helpers';

class ConnectedAccountsModel extends Model {
  id = 'ConnectedAccountsModel';
  persistent = false;
  apiConfig = {
    createAccount: {
      url: '/auth/createConnectedAccount',
      validation: {
        role: {
          type: 'string',
          oneOf: ['patient', 'doctor', 'clinic'],
          required: true
        }
      }
    },
    switchAccount: {
      url: '/auth/switchConnectedAccount',
      validation: {
        id: {
          type: 'number',
          required: true
        }
      }
    },
    updateAvatar: {
      url: 'profile/set/avatar',
      validation: {
        files: 'array'
      },
      cancellable: true
    },
    logoutAll: 'session/logoutAll',
    logoutSid: 'session/logoutSid',
    sessionsList: 'session/list'
  };

  _events = {
    profile: 'handleProfile',
    'foxsocket:message:session_create': 'WSHandleSessionCreate',
    'foxsocket:message:session_remove': 'WSHandleSessionRemove'
  };

  WSHandleSessionCreate = ({ data }) => {
    let sessions = this.getState().sessions || [];
    sessions.push(data);
    this.setState({ sessions: [...sessions] });
  };

  WSHandleSessionRemove = ({ data }) => {
    let sessions = this.getState().sessions || [];
    let index = sessions.findIndex((s) => s.sid === data.sid);
    if (index >= 0) {
      sessions.splice(index, 1);
    }
    this.setState({ sessions: [...sessions] });
  };

  handleProfile = (nextProfile) => {
    const { password, ...profile } = nextProfile;
    void password;
    this.setState({ ...profile, user: profile });
  };

  createAccount = (role) => {
    this.api('createAccount', { role }, (err, res, success) => {
      if (success) {
        this.emit('resetStates');

        AlertManager.popup(AlertManager.TYPES.BASE, {
          close: false,
          active: true,
          body: ({ closeBtn, hide, dataForm, setDataForm }) => {
            return (
              <div className='mc-flex-30-col mc-flex-center'>
                <ThumbnailUploader
                  type={'round'}
                  image={dataForm.avatar}
                  invalid={dataForm.avatar}
                  setImage={(data) => {
                    setDataForm({ error: null });
                    if (!data) return;
                    checkSameAsAvatar(
                      data,
                      res.user?.connectedAccounts
                        .filter((u) => !!u.avatar && u.id !== res.user?.id)
                        .map((u) => u.avatar)
                    ).then((error) => {
                      if (error) return setDataForm({ error });
                      setDataForm({ avatar: data });
                      this.api('updateAvatar', { files: [data] }, () => {
                        hide();
                      });
                    });
                  }}
                  autoLoad={true}
                  activeCloseBtn={false}
                  style={{ width: 120, height: 120 }}
                />
                {dataForm.error && <MCText weight={500} size={20} primary label={dataForm.error} />}
                <MCText weight={500} size={20} textLight label={LANG_CONST.text.choose_avatar} />
                {closeBtn}
              </div>
            );
          }
        });

        setTimeout(() => {
          this.emit('auth', res);
          this.foxsocket().disconnect();
          this.foxsocket().ensureConnect(true);
          this.emit('accountSwitched', res);
        }, 100);
      }
    });
  };

  switchAccount = (id) => {
    this.api('switchAccount', { id }, (err, res, success) => {
      if (success) {
        this.emit('resetStates');

        this.emit('auth', res);
        this.foxsocket().disconnect();
        this.foxsocket().ensureConnect(true);
        this.emit('accountSwitched', res);
      }
    });
  };

  logoutAll = () => {
    let sessions = this.getState().sessions || [];
    let newSessions = sessions.filter((s) => s.sid === config.get('sid'));
    this.setState({ sessions: newSessions });
    this.api('logoutAll', {}, (err, res, success) => {
      if (!success) {
        this.setState({ sessions: sessions });
      }
    });
  };

  logoutSid = (sid) => {
    let sessions = this.getState().sessions || [];
    let session = sessions.find((s) => s.sid === sid);
    session.removing = true;
    this.setState({ sessions: [...sessions] });
    this.api('logoutSid', { logoutSid: sid }, (err, res, success) => {
      sessions = this.getState().sessions || [];
      if (success) {
        let index = sessions.findIndex((s) => s.sid === sid);
        if (index >= 0) {
          sessions.splice(index, 1);
          this.setState({ sessions: [...sessions] });
        }
        // this.sessionsList();
      } else {
        session.removing = false;
        this.setState({ sessions: [...sessions] });
      }
    });
  };

  sessionsList = () => {
    this.api('sessionsList', {}, (err, res, success) => {
      if (success) {
        this.setState({ sessions: res });
      }
    });
  };
}

const model = new ConnectedAccountsModel();
export default model;
